import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeLines: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCodeLines"><Path d="M2.5 4.5H13.5M17.5 4.5H21.5M2.5 12L8.5 12M12.5 12L21.5 12M2.5 19.5L10.5 19.5M14.5 19.5L21.5 19.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCodeLines;
